import React, { Component } from 'react'
import CacheKeys from '../../cache/CacheKeys'
import CacheManager from '../../cache/CacheManager'
import RestApiUtils from '../../apiclient/moebli/RestApiUtils'
import PhoneUpdateStep2UI from './PhoneUpdateStep2UI.js'

class PhoneUpdateStep2SF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      messageList: null,
      errorList: [],
      submitted: false,
    }
  }

  render() {
    return (
      <PhoneUpdateStep2UI
        context={this.props.context}
        messageList={this.state.messageList}
        onSubmit={this.onSubmit}
        submitted={this.state.submitted}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        setErrorList={this.setErrorList}
        // verification code
        verifCode={this.props.verifCode}
        onVerifCodeChange={this.props.onVerifCodeChange}
        verifCodeError={this.props.verifCodeError}
        setVerifCodeError={this.props.setVerifCodeError}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getMessages(context)
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
    if (errorList && errorList.length > 0)
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }

  onSubmit = (event) => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/user/newPhone`,
      this.onSubmitCallback, {
      phoneNumber: this.props.newPhoneNumber,
      verificationCode: this.props.verifCode
    }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    if (response.errorList.length) {
      response.errorList.forEach(error => {
        errorList.push(error.message)
        switch (error.fieldName) {
          case 'phoneNumber':
            this.props.setNewPhoneNumberError(error.message)
            break;
          case 'verificationCode':
            this.props.setVerifCodeError(error.message)
            break;
          default:
        }
      })
    }

    this.setErrorList(errorList)

    this.setState({
      successMsg: response.success,
      submitted: false
    })

    if (errorList.length === 0) {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
      this.props.onUpdatePhoneComplete();
    }
  }

  getMessages(context) {
    let arr = [
      'c_verification_code',
      'c_verify',
      'c_sign_up',
      'c_re_pincode_reset'
    ]
    let keys = arr.join(',')

    let cacheManager = new CacheManager({
      resource: `/api/pub/messages/${keys}/locale/${context.locale}`,
      cacheKey: CacheKeys.Messages('pg_phone_upd_2', context.locale),
      callback: this.getMessagesCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getMessagesCallback = (response) => {
    this.setState({ messageList: response.messageList })
  }
}

export default PhoneUpdateStep2SF
